import * as e from "react";
const o = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", d: "M12 2.586 21.414 12 12 21.414 2.586 12 12 2.586ZM5.414 12 12 18.586 18.586 12 12 5.414 5.414 12Z", clipRule: "evenodd" }));
export {
  o as ReactComponent
};
